import { createContext, useReducer } from "react";
import App from "../App";
import { initialState, reducer } from "../reducer/UserReducer";
// creat react context----------------------------
export const UserContex = createContext();

export default function App2() {
    const [state, dispatch] = useReducer(reducer, initialState);
    
    
  return (
    <>
      <UserContex.Provider value={{ state, dispatch }}>
        <App />
      </UserContex.Provider>
    </>
  );
}
